import addresses from "@constants/addresses";

const chainId = process.env.REACT_APP_CHAIN_ID;

export const StakeVault_CONTRACT_ADDRESS = addresses.stakeVault_contract[chainId];
export const USDC_TOKEN_ADDRESS = addresses.usdc_token[chainId];
export const USDT_TOKEN_ADDRESS = addresses.usdt_token[chainId];